import request from '@/router/axios'
import qs from 'qs'
export function fetchList(query) {
  return request({
    url: '/platformUser/',
    method: 'post',
    params: query
  })
}

export function addObj(obj) {
  return request({
    url: '/platformUser/insert',
    method: 'post',
    params: obj,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function getObj(obj) {
  return request({
    url: '/platformUser/info',
    method: 'post',
    params: obj
  })
}

export function delObj(id) {
  return request({
    url: '/admin/user/' + id,
    method: 'delete'
  })
}

export function putObj(obj) {
  return request({
    url: '/platformUser/update',
    method: 'post',
    params: obj,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
export function updateMyInfo(obj) {
  return request({
    url: '/platformUser/updateMyInfo',
    method: 'post',
    params: obj,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}
// 获取所有角色
export function roleList(query) {
  return request({
    url: '/role/roleList',
    method: 'post',
    params: query
  })
}

// 停用
export function stop(query) {
  return request({
    url: '/platformUser/updateStatus',
    method: 'post',
    params: query
  })
}

//加入企业
export function addcompany(query) {
  return request({
    url: '/platformCompany/updateCompanyAuthStatus',
    method: 'post',
    params: query
  })
}

//修改企业信息
export function compayAuthrz(query) {
  return request({
    url: '/company/compayAuth',
    method: 'post',
    params: query
  })
}

//修改企业信息
export function getAuthInfo(query) {
  return request({
    url: '/company/getAuthInfo',
    method: 'post',
    params: query
  })
}


// 分配角色
export function authRole(query) {
  return request({
    url: '/platformUser/authRole',
    method: 'post',
    params: query,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}


// 停用
export function changePwd(query) {
  return request({
    url: '/platformUser/updatePassword',
    method: 'post',
    params: query
  })
}
// 
export function changeUserPwd(query) {
  return request({
    url: '/platformUser/updateMyPassword',
    method: 'post',
    params: query
  })
}


//修改登录用户信息
export function updateMyInfos(query) {
  return request({
    url: '/platformUser/updateMyInfo',
    method: 'post',
    params: query
  })
}

//获取手号验证码
export function phoneyzm(query) {
  return request({
    url: '/phone/send',
    method: 'post',
    params: query
  })
}

//获取验证参数
export function ruleskey(query) {
  return request({
    url: '/user/validatePhoneCode',
    method: 'post',
    params: query
  })
}

//修改新手机号
export function newphone(query) {
  return request({
    url: '/user/updatePhone',
    method: 'post',
    params: query
  })
}



